import 'react';
import 'react-dom';
import axios from 'axios';
import ReactMount from '@maelstrom-cms/react-mount';

import { configureSentry } from './Sentry'

if (process.env.MIX_SENTRY_DSN) {
    configureSentry({
        dsn: process.env.MIX_SENTRY_DSN,
    });
}

const THIRTY_SECONDS = 30000;

const { language } = require('./helpers');

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Accept-Language'] = `${document.documentElement.lang}`;
axios.defaults.timeout = THIRTY_SECONDS;

let token = document.head.querySelector('meta[name="csrf-token"]');

(async () => {
    const { data } = await axios.get('/actions/Storm/uncachables/run')

    if (token) {
        token.content = data.csrf;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
        window.dataLayer.push({ userId: data.session });

        if (data.is_legacy) {
            const link = document.createElement('link');

            link.href = '/css/app.legacy.css?v=' . data.session;
            link.type = 'text/css';
            link.rel = 'stylesheet';
            link.media = 'screen,print';

            document.getElementsByTagName('head')[0].appendChild(link);
        }
    }
})()

axios.interceptors.request.use(function (config) {
    if (config.url.indexOf('http') === 0) {
        return config;
    }

    if (config.url.indexOf('/') !== 0) {
        config.url = `/${config.url}`
    }

    config.url = `/${language}${config.url}`

    return config;
});

window.axios = axios;

export {
    ReactMount,
    axios,
}
